const PATH = 'fe.components.calibrations.calibration_card';

const messages = {
  buttonExpired: {
    key: `${PATH}.button_expired`,
    defaultValue: 'PURCHASE EXTENSION'
  },
  buttonActive: {
    key: `${PATH}.button_active`,
    defaultValue: 'START CALIBRATION'
  },
  expires: {
    key: `${PATH}.expires`,
    defaultValue: 'Expires'
  },
  buttonAvailable: {
    key: `${PATH}.button_available`,
    defaultValue: 'AVAILABLE {{date}}'
  },
  buttonUnavailable: {
    key: `${PATH}.button_unavailable`,
    defaultValue: 'UNAVAILABLE'
  }
};

export default messages;
